import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import GamePage from "@/pages/GamePage";
import PrayerLinePage from "@/pages/PrayerLinePage";
import AdminPage from "@/pages/AdminPage";
import ProfilePage from "@/pages/ProfilePage";
import PrayedLinkPage from "@/pages/PrayedLinkPage";
import AuthCallback from "@/components/AuthCallback";
import NavBar from "@/components/NavBar";
import { AuthProvider } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Handle Emergent auth hash callback synchronously during render (never in a useEffect)
  if (location.hash && location.hash.includes("session_id=")) {
    return (
      <>
        <NavBar />
        <AuthCallback />
      </>
    );
  }
  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/prayer-line" element={<PrayerLinePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/me" element={<ProfilePage />} />
        <Route path="/prayed/:id" element={<PrayedLinkPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            theme="dark"
            position="top-center"
            toastOptions={{
              style: {
                background: "rgba(15,17,26,0.9)",
                border: "1px solid rgba(255,255,255,0.10)",
                color: "#F8F9FA",
                backdropFilter: "blur(20px)",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
